<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="show-modal-item-modifier-detail"
      data-bs-toggle="modal"
      data-bs-target="#modalItemModifierDetail"
    ></button>
    <div
      class="modal fade"
      id="modalItemModifierDetail"
      tabindex="-1"
      aria-labelledby="modalItemModifierDetailLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Item Name: {{ idSelected.item_no }} / {{ idSelected.item_name }}</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="group-sales">
              <div class="table-responsive p-0 custom-table">
                <table class="table align-items-center mb-0 dataTable" ref="dataTable">
                  <thead>
                    <tr>
                      <th class="text-center font-weight-bolder" >Row No</th>
                      <th class="text-center font-weight-bolder" >Branch Name</th>
                      <th class="text-center font-weight-bolder" >Item No</th>
                      <th class="text-center font-weight-bolder" >Item Name</th>
                      <th class="text-center font-weight-bolder" >Description</th>
                      <th class="text-center font-weight-bolder" >Unit Price</th>
                      <th class="text-center font-weight-bolder" >Quantity</th>
                      <th class="text-center font-weight-bolder" >Item Total</th>
                      <th class="text-center font-weight-bolder" >Group</th>
                      <th class="text-center font-weight-bolder" >Type</th>
                    </tr>
                  </thead>
                  <tbody v-if="items && items.length">
                    <tr v-for="(value, key) in items" :key="key">
                      <td class="text-right text-xss w-5">
                        {{ key + 1 }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.branch_name }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.item_no }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.item_name }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.description }}
                      </td>
                      <td class="text-right text-xss">
                        {{ formatPrice(value?.unit_price) }}
                      </td>
                      <td class="text-right text-xss">
                        {{ value?.qty }}
                      </td>
                      <td class="text-right text-xss">
                        {{ formatPrice(value?.item_total) }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.group }}
                      </td>
                      <td class="text-left text-xss">
                        {{ value?.type }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <material-loading :active="loaderActive" />
              <div class="mt-4 title-page text-end me-4" style="color: #222 !important;">
                Item Total: {{ formatPrice(totalItemTotal) }}
              </div>
              <pagination
                v-if="pagination.last_page > 1"
                :pagination="pagination"
                :current_page="pagination.current_page"
                :last_page="pagination.last_page"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import AnalyticsService from "../../../services/analytics.service";
import Pagination from '@/components/Pagination.vue';

export default {
  name: "ModalItemModifierDetail",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Pagination
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    idSelected: {
      type: Object,
      required: true,
      default: () => ({
        item_no: '',
        item_name: ''
      })
    },
    form: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      items: [],
      pagination: {},
      page: 1,
      totalItemTotal: 0,
      isLoadDone: false,
      isLoadDoneDataTable: false,
    };
  },
  methods: {
    formatPrice(price) {
      return (
        "S$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    getList(page) {
      if (!page) {
        this.isLoadDone = false;
        this.isLoadDoneDataTable = false;
      }

      if (this.idSelected) {
        this.showLoader();
        const formData = {
          ...this.form,
          item_no: this.idSelected.item_no,
          page: page || this.page
        };
        AnalyticsService.itemSalesModifiersReport(formData).then(
          (response) => {
            if (response.data.result.isSuccess) {
              const data = response.data.data;
              this.items = data.data.items;
              this.pagination = data.data;
              this.totalItemTotal = data.total_item_total || 0;

              if (this.pagination.current_page > this.pagination.last_page) {
                this.page = 1;
                this.getList(this.page);
              }

              this.isLoadDone = true;
              this.$nextTick(() => {
                this.isLoadDoneDataTable = true;
              });
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.items = [];
      this.page = 1;
      this.totalItemTotal = 0;
      this.getList(this.page);
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 75vw;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.table-responsive::-webkit-scrollbar {
  height: 7px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

thead tr th {
  border-top-width: 1px !important;
}
</style>
